import LineInterface from 'app/interfaces/LineInterface';
import {isMainLine} from 'app/lines/isMainLine';

export const isNestedLine = (line: LineInterface): boolean => !isMainLine(line);
